<div *ngIf="fetching_attachments">
    <div class="text-center p-3">
        <i class="mx-2 fa fa-spinner fa-spin "></i> Fetching document
    </div>
</div>
<div *ngIf="!cdnPath && !fetching_attachments">
    <div class="text-center p-3">
        No document
    </div>
</div>
<ng-container *ngIf="enable_signed_url">
    <ngx-doc-viewer viewer="google" (loaded)="contentLoaded()" *ngIf="signed_url"
        (googleCheckContentLoaded)="reloading($event)" [url]="(signed_url)"
        style="width: 100%;object-fit: contain;height: 100%;">
    </ngx-doc-viewer>
</ng-container>
<ng-container *ngIf="!enable_signed_url">
    <ngx-doc-viewer viewer="google" (loaded)="contentLoaded()" *ngIf="cdnPath"
        (googleCheckContentLoaded)="reloading($event)" [url]="(google_container_url_document + cdnPath)"
        style="width: 100%;object-fit: contain;height: 100%;">
    </ngx-doc-viewer>
</ng-container>